// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import psigEntity from './entities/psig.json';
import psigMenu from '../pages/psig/menu.json';
import psigFullForm from '../pages/psig/forms/full.json';
import psigContextForm from '../pages/psig/forms/context.json';
import psigMiniForm from '../pages/psig/forms/mini.json';
import psigLookupForm from '../pages/psig/forms/lookup.json';
import psigTableView from '../pages/psig/views/table.json';
import psigStagesView from '../pages/psig/views/stages.json';
import psigCardsView from '../pages/psig/views/cards.json';
import psigInlineView from '../pages/psig/views/inline.json';
import psigBacklogView from '../pages/psig/views/backlog.json';
import psigSplitView from '../pages/psig/views/split.json';
import psigCalendarView from '../pages/psig/views/calendar.json';
import psigDashboardView from '../pages/psig/views/dashboard.json';

/** Тип запису «Сигнал» зі сторінками пакета: меню, форми та подання з pages/psig/. */
export const psigDefinition: IRecordTypeDefinition = {
  ...psigEntity,
  views: assembleViewSet({
      table: psigTableView,
      stages: psigStagesView,
      cards: psigCardsView,
      inline: psigInlineView,
      backlog: psigBacklogView,
      split: psigSplitView,
      calendar: psigCalendarView,
      dashboard: psigDashboardView,
  }),
  form: psigFullForm,
  forms: { full: psigFullForm, context: psigContextForm, mini: psigMiniForm, lookup: psigLookupForm },
  menu: psigMenu,
} as IRecordTypeDefinition;
